import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/logo';
import Iconify from '../../components/iconify';
// sections
// image
import RaindropLogo from '../../image/raindrop_logo.png';
import LoginForm from './LoginForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    backgroundColor: '#F2F4F6',
    minHeight: '100vh',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 600,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  padding: theme.spacing(12, 8),
  borderRadius: '30px',
  boxShadow: theme.customShadows.card,
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title> Login | RainDrop </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm" style={{ display: 'flex', justifyContent: 'center' }}>
          <StyledContent>
            <Stack alignItems="center" spacing={10}>
              <div
                style={{ marginBottom: '60px', cursor: 'pointer' }}
                role="presentation"
                onClick={() => {
                  navigate('/', { replace: true });
                }}
              >
                <img src={RaindropLogo} alt="Raindrop_Logo" />
              </div>
            </Stack>
            <LoginForm />

            {/* <Typography variant="h4" gutterBottom>
              레인드롭 로고
            </Typography> */}

            {/* <Typography variant="body2" sx={{ mb: 5 }}>
              Don’t have an account? {''}
              <Link variant="subtitle2">Get started</Link>
            </Typography> */}

            {/* <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                OR
              </Typography>
            </Divider>

            <Stack direction="row" spacing={2}>
              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
              </Button>
            </Stack> */}
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
